const SeparadorTramos: React.FC<{ className?: string }> = ({ className }) => (
    <svg
      className={className}
      width="100%"
      height="16"
      viewBox="0 0 100 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="0"
        y1="8"
        x2="100"
        y2="8"
        stroke="#A1A1AA" 
        strokeWidth="1"
        strokeDasharray="4 4" 
      />
      <circle cx="8" cy="8" r="2" fill="#3B82F6" />
      <circle cx="32" cy="8" r="2" fill="#3B82F6" />
      <circle cx="56" cy="8" r="2" fill="#3B82F6" />
      <circle cx="80" cy="8" r="2" fill="#3B82F6" />
    </svg>
  );
  
  export default SeparadorTramos;
  